/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const CircleBackButton24 = (props: SVGProps) => (
    <AccessibleSVG width={24} height={24} viewBox="0 0 24 24" {...props}>
        <g fill={vars.bdlGray} fillRule="evenodd">
            <rect width={24} height={24} fillOpacity={0.08} rx={12} />
            <path
                fillRule="nonzero"
                d="M10.906 17.1c.302 0 .545-.094.73-.282a.97.97 0 00.278-.708.895.895 0 00-.096-.42 1.386 1.386 0 00-.236-.328l-1.378-1.417-1.017-.96 7.758.012c.32 0 .576-.05.772-.24.196-.19.283-.442.283-.757s-.087-.568-.283-.76c-.196-.193-.453-.243-.772-.243l-7.759.022 1.018-.964 1.378-1.417c.094-.092.172-.199.236-.321a.91.91 0 00.096-.427.97.97 0 00-.278-.708c-.185-.188-.428-.282-.73-.282a.885.885 0 00-.367.082 1.12 1.12 0 00-.341.246L6.3 11.229c-.2.206-.3.464-.3.774s.1.567.3.768l3.904 4.008c.213.214.447.321.702.321z"
            />
        </g>
    </AccessibleSVG>
);

export default CircleBackButton24;
